export const SYMBOL_SWITCH_POPOVER = Symbol('SWITCH_POPOVER')
export const SYMBOL_SWITCH_POPOVER_ICON = Symbol('SWITCH_POPOVER_ICON')
export const SYMBOL_SWITCH_POPOVER_CONTENT = Symbol('SWITCH_POPOVER_CONTENT')

export const SYMBOL_LABEL = Symbol('LABEL')
export const SYMBOL_ICON = Symbol('ICON')
export const SYMBOL_BUTTON = Symbol('BUTTON')
export const SYMBOL_CHECKBOX = Symbol('CHECKBOX')
export const SYMBOL_FIELD = Symbol('FIELD')
export const SYMBOL_DROPDOWN = Symbol('DROPDOWN')
export const SYMBOL_TOOLTIP = Symbol('TOOLTIP')
export const SYMBOL_BUTTON_ICON = Symbol('BUTTON_ICON')
export const SYMBOL_SWITCH = Symbol('SWITCH')
export const SYMBOL_CHECKMARK = Symbol('CHECKMARK')
export const SYMBOL_SCROLL = Symbol('SCROLL')
export const SYMBOL_LINK = Symbol('LINK')

export const SYMBOL_LAYOUT = Symbol('LAYOUT')
export const SYMBOL_LAYOUT_ITEM = Symbol('LAYOUT_ITEM')

export const SYMBOL_NAVIGATION_SIDEBAR = Symbol('NAVIGATION_SIDEBAR')

export const SYMBOL_CONTROLS_SIDEBAR = Symbol('CONTROLS_SIDEBAR')
export const SYMBOL_COMPONENT_CONTROLS = Symbol('COMPONENT_CONTROLS')
export const SYMBOL_COMPONENT_CONTROLS_BLOCK = Symbol('COMPONENT_CONTROLS_BLOCK')

export const SYMBOL_DEMO_AREA = Symbol('DEMO_AREA')

export const SYMBOL_SOURCE_CODE = Symbol('SOURCE_CODE')
export const SYMBOL_SOURCE_IMPORTS = Symbol('SOURCE_IMPORTS')
export const SYMBOL_CONSOLE = Symbol('CONSOLE')

export const SYMBOL_TABS = Symbol('TABS')
export const SYMBOL_TABS_ITEM = Symbol('TABS_ITEM')

export const SYMBOL_TOOLBAR = Symbol('TOOLBAR')

export const SYMBOL_CONTROL_COLOR = Symbol('CONTROL_COLOR')
export const SYMBOL_CONTROL_SWITCH = Symbol('CONTROL_SWITCH')
export const SYMBOL_CONTROL_DROPDOWN = Symbol('CONTROL_DROPDOWN')
